<template>
  <vuetify-wrapper>
    <div :class="['form-group', classe]">
     <label class="small mb-1" :for="id ? id : name">
      {{ label }}
      <span
        v-if="info"
        class="js-show-tooltip"
        data-toggle="tooltip"
        data-placement="top"
        data-html="true"
        :title="info"
      >
        <i class="fas fa-info-circle p-color"></i>
      </span>
    </label>
    <v-autocomplete
      ref="Autocomplete"
      v-if="multiple"
      v-model="input"
      :items="items"
      :loading="isLoading"
      hide-no-data
      hide-selected
      hide-details
      item-text="value"
      item-value="id"
      :placeholder="placeholder"
      return-object
      chips
      filled
      multiple="multiple"
      class="multi-select"
      :filter="customFilter"
      :clearable="clearable"
    >
      <template #selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          @click="data.select"
        >
          {{ data.item.value }}
          <v-btn
            icon
            small
            @click="remove(data.item)"
            >
            <Icon type="fas" icon="times" />
          </v-btn>
        </v-chip>
      </template>
      <template #item="data">
        <template v-if="data.item">
          <v-list-item-content>
            <span v-if="id" :style="{ fontSize: '14px' }">{{data.item.id}} - {{data.item.value}}</span>
            <span v-else>{{data.item.value}}</span>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>

    <v-autocomplete
      v-else
      ref="Autocomplete"
      v-model="input"
      :items="items"
      :loading="isLoading"
      hide-no-data
      hide-details
      item-text="value"
      item-value="id"
      :placeholder="placeholder"
      return-object
      filled
      :filter="customFilter"
      :clearable="clearable"
      class="single-select"
      @input="change"
    >
      <template #item="data">
        <template v-if="data.item">
          <v-list-item-content>
            <span v-if="id" :style="{ fontSize: '14px' }">{{data.item.id}} - {{data.item.value}}</span>
            <span v-else>{{data.item.value}}</span>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
  </vuetify-wrapper>
</template>

<script>
import Icon from '@/components/vue/ui/Icon.vue';

export default {
  name: 'Autocomplete',
  components: {
    Icon,
  },
  props: {
    classe: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object, String, Number],
      default: () => null,
    },
  },
  data() {
    return {
      input: this.multiple ? (this.value || []) : (this.value || null),
      isLoading: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (this.multiple) {
          this.input = newValue || [];
        } else {
          this.input = newValue || null;
        }
      },
    },
    input(newValue) {
      if (this.multiple) {
        this.changeMulti(newValue);
      }
    },
  },
  methods: {
    customFilter(item, queryText) {
      const value = item.value.toLowerCase();
      const query = queryText.toLowerCase();
      const codigo = String(item.id);
      return (value.includes(query) || codigo.includes(query));
    },
    change(e) {
      this.rules = '';
      if (e && e.target) {
        e.name = this.name;
      }
      this.$emit('input', e || null);
    },
    changeMulti(e) {
      this.input = e;
      this.$emit('input', e);
    },
    remove(item) {
      const index = this.input.findIndex((findItem) => item.id === findItem.id);
      if (index >= 0) {
        this.input.splice(index, 1);
      }
      this.$emit('input', this.input);
    },
  }
};
</script>
